import externalBlocStore from "./externalBlocStore";
import useBloc from "./useBloc";
const useBlocNext = useBloc;

export { externalBlocStore, useBloc, useBlocNext };
